module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "tcc-header"
  }, [_c('button', {
    staticClass: "skip-to-content",
    on: {
      "click": _vm.skipToContent
    }
  }, [_vm._v("Skip to content")]), _vm._v(" "), _c('div', {
    staticClass: "tcc-header__inner"
  }, [_c('div', {
    staticClass: "tcc-header__container"
  }, [_c('router-link', {
    staticClass: "tcc-header__logo",
    class: this.customLogo ? 'industry-logo' : '',
    style: ({
      backgroundImage: this.customLogo ? 'url(' + _vm.getFullServerPath(this.customLogo) + ')' : ''
    }),
    attrs: {
      "to": "/",
      "title": "The Clear Company logo"
    }
  }), _vm._v(" "), (!_vm.getDeviceType('mobile') && !_vm.getDeviceType('tablet')) ? _c('ul', {
    staticClass: "tcc-header__menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home',
        hash: '#features'
      }
    }
  }, [_vm._v("Features")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home',
        hash: '#our-clients'
      }
    }
  }, [_vm._v("Our clients")])], 1), _vm._v(" "), _c('li', {
    staticClass: "separator"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home',
        hash: '#pricing'
      }
    }
  }, [_vm._v("Pricing")])], 1), _vm._v(" "), _vm._l((_vm.headerData), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": _vm.routeName(item.url),
        "title": item.alt
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.getDeviceType('mobile') || _vm.getDeviceType('tablet')) ? _c('button', {
    staticClass: "tcc-header__menu--trigger",
    attrs: {
      "aria-expanded": _vm.mobileMenuShown,
      "aria-controls": "mobileMenuContainer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.mobileMenuShown = !_vm.mobileMenuShown
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-bars",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "bars",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M424 392H23.1C10.8 392 0 402.8 0 415.1C0 429.2 10.8 440 23.1 440H424c13.2 0 24-10.8 24-23.1C448 402.8 437.2 392 424 392zM424 72H23.1C10.8 72 0 82.8 0 95.1S10.8 120 23.1 120H424c13.2 0 24-10.8 24-23.1S437.2 72 424 72zM424 232H23.1C10.8 232 0 242.8 0 256c0 13.2 10.8 24 23.1 24H424C437.2 280 448 269.2 448 256S437.2 232 424 232z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Menu")]), _vm._v(" "), _c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M432.6 209.3l-191.1 183.1C235.1 397.8 229.1 400 224 400s-11.97-2.219-16.59-6.688L15.41 209.3C5.814 200.2 5.502 184.1 14.69 175.4c9.125-9.625 24.38-9.938 33.91-.7187L224 342.8l175.4-168c9.5-9.219 24.78-8.906 33.91 .7187C442.5 184.1 442.2 200.2 432.6 209.3z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.mobileMenuShown && (_vm.getDeviceType('mobile') || _vm.getDeviceType('tablet'))) ? _c('div', {
    ref: "mobileMenuContainer",
    staticClass: "tcc-header__mobile-menu",
    attrs: {
      "id": "mobileMenuContainer",
      "aria-expanded": _vm.mobileMenuShown
    }
  }, [_c('div', {
    staticClass: "tcc-header__mobile-menu--inner"
  }, [_c('ul', {
    staticClass: "tcc-header__mobile-menu--list"
  }, _vm._l((_vm.headerData), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": _vm.routeName(item.url),
        "title": item.alt
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), 0)])]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41190443","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/common/AuthorizationHeader.vue
// module id = 979
// module chunks = 0